define.alias("shared/errors/api-not-found-error", "settings/errors/api-not-found-error");